/* 
    This Class manages the right Form Input Elements between Client and Cosignee selection
    Also it creates the Ajax Request for Editions and DeliveryDate
*/

export class Form {
    constructor() {
        this.client = document.querySelector('.ce.userinfo');
        this.consignee = document.querySelector('.ce.consignee');
    }
    
    get isReady() {
        return (!this.street || !this.housenumber || !this.postcode || !this.city) ? false : true;
    }
    
    get street() {
        return this.getElement('street');
    }
    
    set street(value) {
        this.setElement('street', value);
    }
    
    get housenumber() {
        return this.getElement('housenumber');
    }
    
    set housenumber(value) {
        this.setElement('housenumber', value);
    }
    
    get postcode() {
        return this.getElement('postcode');
    }
    
    set postcode(value) {
        this.setElement('postcode', value);
    }
    
    get city() {
        return this.getElement('city');
    }
    
    set city(value) {
        this.setElement('city', value);
    }
    
    get country() {
        return this.getElement('country') ? this.getElement('country') : 'Deutschland';
    }
    
    getElement(name) {
        let input = (this.consignee) ? this.consignee : this.client;
        let element = input.querySelector('input[name*="'+name+'"], select[name*="'+name+'"]');
        return (element) ? element.value : false;
    }
    
    getElementName(name) {
        let input = (this.consignee) ? this.consignee : this.client;
        let element = input.querySelector('input[name*="'+name+'"], select[name*="'+name+'"]');
        return (element) ? element.getAttribute('name') : '';
    }

    getRawElement(name) {
        let input = (this.consignee) ? this.consignee : this.client;
        let element = input.querySelector('input[name*="'+name+'"], select[name*="'+name+'"]');
        return (element) ? element : false;
    }
    
    setElement(name, value) {
        let input = (this.consignee) ? this.consignee : this.client;
        let element = input.querySelector('input[name*="'+name+'"], select[name*="'+name+'"]');
        if (element) {
            element.value = value;
        }
        element.dispatchEvent(new Event('change'));
    }
    
    hasUpdated(name) {
        let input = (this.consignee) ? this.consignee : this.client;
        let element = input.querySelector('input[name*="'+this.plainName(name)+'"], select[name*="'+this.plainName(name)+'"]');
        return (element && element.value != element.dataset.old) ? true : false;
    }
    
    plainName(name) {
        let matches = name.match(/\[(.*?)\]/);
        return matches[1] || name;
    }
}
